import Seo from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import CategorySection from "@/components/sections/CategorySection";
import BrandSection from "@/components/sections/BrandSection";
import FeaturedSection from "@/components/sections/FeaturedSection";
import TrustSection from "@/components/sections/TrustSection";
import WarrantySection from "@/components/sections/WarrantySection";
import AboutSection from "@/components/sections/AboutSection";
import ContactSection from "@/components/sections/ContactSection";
import { HomeownerStrip, ServiceStrips } from "@/components/sections/HomeStrips";
import { SITE } from "@/data/site";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    name: SITE.fullName,
    alternateName: SITE.name,
    description: SITE.description,
    telephone: SITE.phone,
    email: SITE.email,
    url: typeof window !== "undefined" ? window.location.origin : undefined,
  };

  return (
    <>
      <Seo
        title="CA HVAC Direct — Professional HVAC Equipment, Direct"
        description={SITE.description}
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <CategorySection />
      <FeaturedSection />
      <BrandSection />
      <TrustSection />
      <HomeownerStrip />
      <ServiceStrips />
      <WarrantySection />
      <AboutSection />
      <ContactSection />
    </>
  );
}
